import { createFileRoute } from "@tanstack/react-router";
import { ContractSharePage } from "@/features/contracts/contract-share-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/udzial")({
	component: ContractSharePage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.kontrakty.udzial", location.pathname);
	},
});
